"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class DenyAllPermissionChecker {
  is(_profile) {
    return false;
  }
  isOrganizationMember(_organization) {
    return false;
  }
  hasOrganizationRole(_roleName, _organization) {
    return false;
  }
  isOrganizationAdmin(_organization) {
    return false;
  }
  isOmniAdmin() {
    return false;
  }
  hasGroupRole(_roleName, _group) {
    return false;
  }
  isGroupAdmin(_group) {
    return false;
  }
  canCreateOrganization() {
    return false;
  }
  canUpdateOrganization(_organization) {
    return false;
  }
  canDeleteOrganization(_organization) {
    return false;
  }
  canCreateProfile(_organization) {
    return false;
  }
  canUpdateProfile(_profile) {
    return false;
  }
  canDeleteProfile(_profile) {
    return false;
  }
  canCreateGroup(_organization) {
    return false;
  }
  canUpdateGroup(_group) {
    return false;
  }
  canDeleteGroup(_group) {
    return false;
  }
  canUpdatePassword(_user) {
    return false;
  }
  canUpdatePasswordWithoutOld(_user) {
    return false;
  }
  canCreateApplication() {
    return false;
  }
  canImpersonateProfile(_profile) {
    return false;
  }
  canDeleteApplication() {
    return false;
  }
  canUpdateApplication(_application) {
    return false;
  }
  canCreateUser() {
    return false;
  }
  canDeleteUser() {
    return false;
  }
  canUpdateUser() {
    return false;
  }
  canCreateProfileShare(_profileShare) {
    return false;
  }
  canDeleteProfileShare(_profileShare) {
    return false;
  }
  canUpdateProfileShare(_profileShare) {
    return false;
  }
  canAcceptCollaboration(_organization) {
    return false;
  }
}
exports.default = DenyAllPermissionChecker;